import React from 'react';
import PropTypes from 'prop-types';
import { Redirect, Route } from 'react-router-dom';
import { connect } from 'react-redux';

import { isTokenExpired } from './validators';
import { refreshToken, setTokenExpiredTrue } from '../actions/loginActions';
import DefaultLayout from '../components/Layouts/DefaultLayout';
import Routes from '../constants/routes';
import { getUser, removeUser } from './utils';


const PrivateRoute = ({
    component: Component, setTokenExpiredTrue: setTokenExpiredMessage, ...rest
}) => {
    refreshToken();

    return (
        <Route
            {...rest}
            render={(props) => {
                const user = getUser();
                if (Object.keys(user).length === 0 || !user.token) {
                    return (
                        <Redirect to={{
                            pathname: Routes.login,
                            state: { from: props.location },
                        }}
                        />
                    );
                }

                if (isTokenExpired(user) && !user.rememberMe) {
                    removeUser();
                    setTokenExpiredMessage();

                    return (
                        <Redirect to={{
                            pathname: Routes.login,
                            state: { from: props.location },
                        }}
                        />
                    );
                }

                return <DefaultLayout><Component {...props} /></DefaultLayout>;
            }}
        />
    );
};

const mapDispatchToProps = dispatch => ({
    setTokenExpiredTrue: () => dispatch(setTokenExpiredTrue),
});


PrivateRoute.propTypes = {
    component: PropTypes.any.isRequired,
    setTokenExpiredTrue: PropTypes.func.isRequired,
    location: PropTypes.any.isRequired,
};

export default connect(null, mapDispatchToProps)(PrivateRoute);
